import React from 'react';

import { CarouselCardProps } from '../types';

import {
    Wrapper,
    LinkWrapper,
    ImageWrapper,
    Image,
    ContentWrap,
    Content,
    Header,
    Body,
} from './styles';

export const MobileCarouselCard = ({
    onClickCTA,
    isTablet,
    campaignBannerContent: {
        title,
        text,
        textColor,
        cta,
        carouselImage,
        carouselMobileImage,
        carouselTabletImage,
        backgroundColor,
    },
    clickClassName,
    className,
}: CarouselCardProps) => {
    const handleCtaCLick = () => {
        onClickCTA();
    };

    const sliderImage = isTablet ? carouselTabletImage?.url : carouselMobileImage?.url;

    return (
        <Wrapper className={className}>
            <LinkWrapper
                className={clickClassName}
                external={!cta.internal}
                target="_self"
                to={cta.url}
                onClick={handleCtaCLick}
            >
                <ImageWrapper>
                    <Image
                        imgUrls={sliderImage ?? carouselImage?.url}
                        src={sliderImage ?? carouselImage?.url}
                        lazy={false}
                        backgroundImage={sliderImage ?? carouselImage?.url}
                    />
                </ImageWrapper>
                <ContentWrap backgroundColor={backgroundColor}>
                    <Content>
                        <Header textColor={textColor}>{title}</Header>
                        <Body textColor={textColor} html={text} />
                    </Content>
                </ContentWrap>
            </LinkWrapper>
        </Wrapper>
    );
};
